import * as React from 'react';
import { FormattedHTMLMessage } from 'react-intl';


import {
    VerificationService,
    SuccessResponse,
    setFocus,
    CopyToClipboard,
} from '@sheerid/jslib';


interface StepSuccessProps {
    verificationService: VerificationService;
}

function StepSuccessComponent({ verificationService }: StepSuccessProps) {
    // eslint-disable-next-line no-template-curly-in-string
    const rewardCode = (verificationService.verificationResponse as SuccessResponse).rewardCode || '${rewardCode}';

    return (
        <div id="sid-step-success" className="sid-l-container">

            {/* Set Focus to header */}
            {setFocus('sid-header__title')}
            <img className="sid-header__logo" src="https://assets-resources.sheerid.com/jcrew/img/jcrew-logo-cursive.png" alt="" />
            <div className="sid-header sid-l-horz-center sid-l-space-top-md">
                <div className="sid-l-horz-center" />
                <h2 className="sid-header__title sid-l-horz-center sid-l-space-top-md">
                    <FormattedHTMLMessage id="step.success.title" defaultMessage="Great Work!" />
                </h2>
                <div className="sid-header__subtitle-success sid-l-horz-center sid-l-two-thirds-width">
                    <FormattedHTMLMessage id="step.success.subtitle" defaultMessage="Thanks for confirming your student status. <br><br>Just use this code at checkout to receive 15% off your purchase at <a href='https://jcrew.com' target='_blank' class='sid-jcrew-link'>jcrew.com</a>.*" />
                </div>
            </div>

            <div className="sid-reward-code sid-l-space-top-lg sid-h-jumbo-text sid-l-horz-center">
                {rewardCode}
            </div>

            <div className="sid-l-space-top-md sid-h-bold-text sid-l-horz-center">
                <CopyToClipboard
                    textToCopy={rewardCode}
                >
                    <FormattedHTMLMessage id="step.success.copyCouponCode" defaultMessage="Copy Coupon code" />
                </CopyToClipboard>
            </div>

            <div className="sid-emailed-copy-footer sid-l-horz-center sid-l-space-top-lg sid-success-footer-one">
                <FormattedHTMLMessage id="step.success.returnTo" defaultMessage="Please return to <a href='https://jcrew.com' target='_blank' class='sid-jcrew-link'>jcrew.com</a>  to continue shopping." />
            </div>

            <div className="sid-emailed-copy-footer sid-l-horz-center sid-l-space-top-lg sid-success-footer-two">
                <FormattedHTMLMessage id="step.success.useDiscount" defaultMessage="To make sure you have every opportunity to use your discount, we're also emailing you a copy of your code and a link to the <a href='https://jcrew.com' target='_blank' class='sid-jcrew-link'>jcrew.com</a> website so that you can shop now, or shop later. Please check for an email from us (verify@sheerid.com) for all the details." />
            </div>

            <div className="sid-last-footer">
                <span className="sid-footer-one">
                    <FormattedHTMLMessage
                        id="step.personalInfo.lastFooter"
                        defaultMessage="Verification services hosted by SheerID."
                    />
                </span>

                <p className="sid-footer-two">
                    <FormattedHTMLMessage id="step.success.footerLinkOne" defaultMessage="<a href='https://verify.sheerid.com/student-faq/' target='_blank' class='sid-footer-two'>SheerID FAQs</a>" />
                    {' '}
&nbsp;
                    <FormattedHTMLMessage id="step.success.footerLinkTwo" defaultMessage="<a href='https://www.sheerid.com/privacy-policy/' target='_blank' class='sid-footer-two'>SheerID Privacy Policy</a>" />
                </p>

                <p className="sid-footer-three">
                    <FormattedHTMLMessage id="step.success.footerThree" defaultMessage="*15% discount valid in J.Crew stores and at jcrew.com. Not valid in J.Crew Factory stores; at jcrewfactory.com; or on phone orders. Offer cannot be applied to previous purchases or the purchase of gift cards and cannot be redeemed for cash. Exclusions apply; see a store associate or the link in the top banner at jcrew.com for an up-to-date list. To redeem in stores, present a valid student or teacher ID at checkout. To redeem online, enter the unique code provided in the promo code box at online checkout. Offer valid in the U.S. only." />
                    {' '}
&nbsp;
                </p>
            </div>
        </div>
    );
}


export { StepSuccessComponent };
